import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

import { getInspectionsByStatus, InspectionsListShipOperator } from '@/services/dashboardService';
import { LoadingSpinner } from '@/components/Dashboard/LoadingSpinner';
import { getCurrentMonth } from '@/utils/date';

import MonthSelector from './MonthSelector';
import './dashboard.css';
import { DataStatus } from './dataStatus';
import chartColors from './chartColors';
import { SMALL_SCREEN_WIDTH_LIMIT } from '@/common/constants';

const labels: {[key: string]: string} = {
    'inprogress': 'In Progress',
    // 'pending': 'Pending',
    // 'allclear': 'All Clear',
    'cancel': 'Cancelled',
    'done': 'Done',
};

const emptyData: {[key: string]: number} = {
    'inprogress': 0,
    // 'pending': 0,
    // 'allclear': 0,
    'cancel': 0,
    'done': 0,
};

const { blue, red, green } = chartColors;

const ChartInspectionsByStatus = () => {
    const {year: currentYear, month: currentMonth} = getCurrentMonth();

    const [data, setData] = useState<{[key: string]: number}>(emptyData);
    const [dataStatus, setDataStatus] = useState<DataStatus>(DataStatus.LOADING);
    const [month, setMonth] = useState<number>(currentMonth);
    const [year, setYear] = useState<number>(currentYear);

    const transformData = (originalData: InspectionsListShipOperator): {[key: string]: number} => ({
        'inprogress': originalData.inProgressNominationInspectionProcess,
        // 'pending': originalData.inspectionInvoicesNotYetPaid,
        // 'allclear': originalData.inspectionInvoicesCompleted + originalData.inspectionInvoicesPaid,
        'cancel': originalData.cancelledNominationInspectionProcess,
        'done': originalData.finishedInspectionProcess,
    });

    const getData = async (month: number, year: number) => {
        setDataStatus(DataStatus.LOADING)
        const response = await getInspectionsByStatus(month, year);
        if (!response.data){
            setDataStatus(DataStatus.ERROR);
            return;
        }
        if (response.data[0] == null){
            setDataStatus(DataStatus.EMPTY);
            return;
        }
        const originalData = response.data[0] as InspectionsListShipOperator;
        setData(transformData(originalData))
        setDataStatus(DataStatus.OK);
    };

    useEffect(() => {
        getData(currentMonth, currentYear);
    }, []);

    useEffect(() => {
        getData(month, year);
    }, [month, year]);

    const chartOptions: ApexCharts.ApexOptions = {
        chart: {
            type: 'pie',
        },
        dataLabels: {
            formatter: (_val, opts) => (opts.w.config.series[opts.seriesIndex]) // replaces percentages with numbers
        },
        labels: Object.values(labels),
        legend: {
            show: true,
            position: 'bottom',
            formatter: function (seriesName, opts) {
                const seriesIndex = opts.seriesIndex;
                const value = opts.w.globals.series[seriesIndex]; 
                return `${seriesName} (${value ?? 0})`;
            }
        },
        colors: [blue, red, green],
        responsive: [{
            breakpoint: SMALL_SCREEN_WIDTH_LIMIT,
            options: {
                legend: {
                    position: 'bottom',
                    formatter: (legendName: string, opts: any) => (`${legendName} (${opts.w.globals.series[opts.seriesIndex]})`),
                }
            }
        }]
    };

    return (
        <div className='card card-pie' style={{width: '100%'}}>
            <h2 className='card-title'>Inspections</h2>
            <div>
                <MonthSelector month={month} year={year} onChange={(selectedMonth, selectedYear) => { setMonth(selectedMonth); setYear(selectedYear) }} />
                {(dataStatus === DataStatus.LOADING) && <LoadingSpinner />}
            </div>
            {(dataStatus === DataStatus.EMPTY || dataStatus === DataStatus.ERROR) && <div>No data to display</div>}
            {(dataStatus === DataStatus.OK || dataStatus === DataStatus.LOADING) && <ReactApexChart type="pie" options={chartOptions} series={Object.values(data)} height={420} />}
        </div>
    );
};

export default ChartInspectionsByStatus;
